"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Category_1 = __importDefault(require("../entity/Category"));
class CategoryStub extends Category_1.default {
    constructor({ id = 'ABC', name = '少年漫画', parentCategory = Category_1.default.fromJSON({ id: 'DEF', name: '青年漫画' }), } = {}) {
        super({ id, name, parentCategory });
    }
}
exports.default = CategoryStub;
